"use strict";

var $ = window.jQuery = window.$ = require("./..\\..\\..\\bower_components\\jquery\\dist\\jquery.js");

require("./..\\..\\..\\bower_components\\bootstrap\\dist\\js\\bootstrap.js");
require("./..\\..\\..\\bower_components\\metisMenu\\dist\\metisMenu.js");
require("./..\\..\\..\\bower_components\\jquery-slimscroll\\jquery.slimscroll.js")
require("./..\\..\\..\\bower_components\\jquery-slimscroll\\jquery.slimscroll.min.js")
require('./modules/inspiniaInit')();
require("./..\\..\\..\\bower_components\\PACE\\pace.js");
window.Handlebars = require("./..\\..\\..\\bower_components\\handlebars\\handlebars.js");
require("./..\\..\\..\\bower_components\\datatables.net\\js\\jquery.dataTables.js")(window, $);

// Init wrappers for plugins

$(function () {
	require('./modules/icheckInit')();
	require('./modules/handlebarsInit')();
	require('./modules/reportFormInit')();
	require('./modules/reportStepInit')();
	require('./modules/updateFormInit')();
	require('./modules/reportButtonsInit')();
	require('./modules/navigatingPagesInit')();
});